// import { useState, useEffect } from "react";
import "../customCss/Sidebar.css";
import Log from "../images/wevillage_logo_main.webp";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const { pathname } = useLocation();

  // const [menuOpen, setMenuOpen] = useState({
  //   winter: false,
  //   snowShoveling: false,
  //   snowBank: false,
  //   summer: false,
  // });

  // const toggleMenu = (menu) => {
  //   setMenuOpen((prev) => ({
  //     ...prev,
  //     [menu]: !prev[menu],
  //   }));
  // };
  // useEffect(() => {
  //   setMenuOpen({
  //     winter: pathname.includes("winter-form-fields"),
  //     snowShoveling: pathname.includes("snow-shovel-fields"),
  //     snowBank: pathname.includes("snow-bank-fields"),
  //     summer: pathname.includes("summer-form-fields"),
  //     account: pathname.includes("users"),
  //   });
  // }, [pathname]);

  return (
    <aside>
      <div className="main_sidebar">
        <div className="sidebar_top">
          <img src={Log} alt="" />
          <h5>Logged in as:</h5>
          <h6>Admin</h6>
        </div>
        <div className="sidebar_body">
          <ul className="mainMenu">
            {/* <li className={pathname.includes("statistics") ? "activated" : ""}>
              <Link to="#">
                <i className="fas fa-chart-bar"></i>Statistics
              </Link>
            </li> */}
            <li
              className={
                pathname.includes("flexcare-bookings") ? "activated" : ""
              }
            >
              <Link to="/flexcare-bookings">
                <i className="fas fa-calendar-alt"></i>Flexcare Bookings
              </Link>
            </li>
            <li
              className={
                pathname.includes("winter-camp-bookings") ? "activated" : ""
              }
            >
              <Link to="/winter-camp-bookings">
                <i className="fas fa-snowflake"></i>Winter Camp Bookings
              </Link>
            </li>
            <li className={pathname.includes("all-users") ? "activated" : ""}>
              <Link to="/all-users">
                <i className="fas fa-users" />
                All Users
              </Link>
            </li>
            <li
              className={pathname.includes("program-prices") ? "activated" : ""}
            >
              <Link to="/program-prices">
                <i className="fas fa-dollar-sign" />
                Program Prices
              </Link>
            </li>
            <li
              className={pathname.includes("invoices") ? "activated" : ""}
            >
              <Link to="/invoices">
                <i className="fas fa-print" />
                Invoices
              </Link>
            </li>
            {/* <li>
              <div
                onClick={() => toggleMenu("account")}
                className="d-flex align-items-center justify-content-between"
              >
                <Link to="#">
                  <i className="fas fa-users"></i>App Registration Details
                </Link>
                <i
                  className={`fas fa-chevron-${
                    menuOpen.account ? "up" : "down"
                  } ms-auto`}
                />
              </div>
              {menuOpen.account && (
                <ul className="subMenu">
                  <li
                    className={
                      pathname === "/users/house-owners" ? "activated" : ""
                    }
                  >
                    <Link to="/users/house-owners">
                      <i className="fas fa-user-tie"></i>House Owner
                    </Link>
                  </li>
                  <li
                    className={
                      pathname === "/users/contractors" ? "activated" : ""
                    }
                  >
                    <Link to="/users/contractors">
                      <i className="fas fa-user"></i>Contractors
                    </Link>
                  </li>
                </ul>
              )}
            </li> */}
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
